import React from 'react';
export const BeforeAfter: React.FC = () => {
  const beforeItems = ['Mirás joyas sin saber si son reales', 'No tenés herramientas para verificar', 'Te ofrecen precios y no sabés si son justos', 'Dependés de la honestidad del otro', 'Sentís que "no es para vos"'];
  const afterItems = ['Identificás oro real en segundos con 6 pruebas', 'Calculás el valor exacto en USD y pesos', 'Sabés dónde comprar barato y vender caro', 'Negociás con datos, no con intuición', 'Hacés tu primera operación en 7 días'];
  return <section className="py-20" data-id="element-16">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-17">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-18">
          Tu vida{' '}
          <span style={{
          color: 'var(--gold)'
        }} data-id="element-19">
            antes y después
          </span>{' '}
          de esta guía
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-20">
          {/* Before */}
          <div className="rounded-xl p-8 border" style={{
          background: 'var(--bg-card)',
          borderColor: 'var(--border-subtle)'
        }} data-id="element-21">
            <h3 className="font-bold text-sm uppercase tracking-widest mb-5" style={{
            color: 'var(--red-alert)'
          }} data-id="element-22">
              ✗ Sin la guía
            </h3>
            <ul data-id="element-23">
              {beforeItems.map((item, index) => <li key={index} className="py-2.5 pl-6 relative text-sm" style={{
              color: 'var(--text-secondary)',
              borderBottom: index < beforeItems.length - 1 ? '1px solid rgba(255,255,255,0.04)' : 'none'
            }} data-id="element-24">
                  <span className="absolute left-0 font-bold" style={{
                color: 'var(--red-alert)'
              }} data-id="element-25">
                    –
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          {/* After */}
          <div className="rounded-xl p-8 border" style={{
          background: 'var(--bg-card)',
          borderColor: 'var(--border-gold)',
          boxShadow: 'var(--shadow-gold)'
        }} data-id="element-26">
            <h3 className="font-bold text-sm uppercase tracking-widest mb-5" style={{
            color: 'var(--green-ok)'
          }} data-id="element-27">
              ✓ Con la guía
            </h3>
            <ul data-id="element-28">
              {afterItems.map((item, index) => <li key={index} className="py-2.5 pl-6 relative text-sm" style={{
              color: 'var(--text-secondary)',
              borderBottom: index < afterItems.length - 1 ? '1px solid rgba(255,255,255,0.04)' : 'none'
            }} data-id="element-29">
                  <span className="absolute left-0 font-bold" style={{
                color: 'var(--green-ok)'
              }} data-id="element-30">
                    ✓
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
};